.wrapper {
  position: relative;
  display: inline-flex;
}

.tooltip {
  position: fixed;
  transform: translateX(-50%);
  z-index: 1000;
  min-width: 100px;
  max-width: 320px;
  padding: 6px 10px;
  background-color: var(--color-grey-dark);
  color: #fff;
  border-radius: map.get($radius, 'sm');
  white-space: pre-wrap;
  text-align: center;
  pointer-events: none;

  @include metadata-regular;

  animation: fadeIn 0.12s ease-out;
}

.top {
  transform: translateX(-50%) translateY(-100%);
}

.bottom {
  // top is set inline, no extra Y transform needed
  transform: translateX(-50%);
}

.arrow {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.top .arrow {
  bottom: -4px;
  border-top: 4px solid var(--color-grey-dark);
}

.bottom .arrow {
  top: -4px;
  border-bottom: 4px solid var(--color-grey-dark);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
